<template>
  <b-card class="mb-3">
    <h6 slot="header" class="mb-0 text-danger">
      <font-awesome-icon icon="exclamation-triangle" /> แจ้งเตือนการไม่อนุมัติโครงการ
    </h6>

    <strong>สถานะก่อนหน้า:</strong> {{ PROJECT_STATUS_TEXT[changes.prevStatus] }}<br>
    <strong>สถานะปัจจุบัน:</strong> {{ PROJECT_STATUS_TEXT[changes.currentStatus] }}<br>
    <strong>ผู้กระทำ:</strong> {{ changes.user.thFullName }}<br>
    <strong>เหตุผล/ความเห็น: </strong>
    <!-- // eslint-disable-next-line vue/no-v-html -->
    <div v-html="changes.comment" />
  </b-card>
</template>

<script>
import { PROJECT_STATUS_TEXT } from '@/constants'

export default {
  props: {
    changes: { type: Object, required: true }
  },
  data: () => ({
    PROJECT_STATUS_TEXT
  })
}
</script>

<style>

</style>
